export enum PackagingType {
    None='None',
    Packed='Packed',
    UnPacked='UnPacked'
}